<template>
  <div class="goods_logistics_setup">
    <!--tabs切换-->
    <div class="baby_manage_tabs_box">
      <ul>
        <li @click="tabsChange('goodsLogistics')">货品物流设置</li>
        <li class="active">通用物流设置</li>
      </ul>
    </div>
    <!--通用物流设置查询头部-->
    <div class="goods_logistics_setup_top">
      <div class="w_percent14">
        <el-select v-model="selectChannel" multiple collapse-tags placeholder="渠道">
          <el-option
            v-for="item in channelList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="w_percent14">
        <el-select v-model="selectStore" multiple collapse-tags placeholder="店铺">
          <el-option
            v-for="item in storeList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="w_percent14">
        <el-select v-model="selectClassificationType" multiple collapse-tags placeholder="分类">
          <el-option
            v-for="item in codeClassificationList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="w_percent14">
        <el-select v-model="selectProvince" placeholder="省份">
          <el-option
            v-for="item in provincesList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="w_percent14">
        <el-select v-model="selectCourierCompany" multiple collapse-tags placeholder="快递公司">
          <el-option
            v-for="item in courierCompanyList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="h32">
        店铺售价
      </div>
      <div class="w70"><input type="text" v-model.number="minNum" @blur="judgeNum(minNum, 'min')" placeholder="最小值"></div>
      <div class="w9 h32">~</div>
      <div class="w70"><input type="text" v-model.number="maxNum" @blur="judgeNum(maxNum, 'max')" placeholder="最大值"></div>
      <!--<div class="w70">
        <el-select v-model.trim="selectSymbolType" placeholder="符号">
          <el-option
            v-for="item in symbolType"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>-->
      <!--<div class="w70"><input type="text" v-model.trim="num" title="数值"></div>-->
      <div>
        <button class="btn_normal ml10 mr20" @click="ctrlBtn('batchDel', null)">批量删除</button>
        <button class="btn_normal ml10" @click="ctrlBtn('add', null)">增加</button>
        <button class="btn_normal" @click="query()">查询</button>
      </div>
    </div>
    <!--通用物流设置查询内容-->
    <div class="goods_logistics_setup_content">
      <table class="table tb_border">
        <thead>
        <tr>
          <th style="width: 30px;"><input type="checkbox" title="全选" v-model="checkAll" @click="checkOneOrAll()"/></th>
          <th>渠道</th>
          <th>店铺</th>
          <th>分类</th>
          <th>省份</th>
          <th>店铺售价</th>
          <th>快递</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody v-if="list.length">
        <tr v-for="(item, index) in list" :key="index">
          <td style="width: 30px;"><input type="checkbox" title="选择" v-model="checkboxModel[index]"></td>
          <td>{{item.StoreroomName}}</td>
          <td>{{item.ShopName}}</td>
          <td>{{item.ClassName}}</td>
          <td>{{item.ProvinceName}}</td>
          <td>{{item.Price}}</td>
          <td>{{item.LogisticName}}</td>
          <td><a class="fcLinkA" @click="ctrlBtn('del', item)">删除</a></td>
        </tr>
        </tbody>
        <tbody v-if="!list.length">
        <tr>
          <td colspan="8">暂时没有相关信息</td>
        </tr>
        </tbody>
      </table>

      <!--分页-->
      <div class="paging" v-if="list.length">
        <el-pagination
          background
          :prev-text="'上一页'"
          :next-text="'下一页'"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 15, 20, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!--弹出框-->
    <general-logistics-setup-embed-msg v-if="isShow"
                                       :title="dialogTitle"
                                       :showType="dialogShowType"
                                       :msg="dialogMsg" @cancelbtn="getSelectDialogEmbed"></general-logistics-setup-embed-msg>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeMsgDialog"></msg-dialog>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="'NOP'"></loading-dialog>
  </div>
</template>

<script>
  import GeneralLogisticsSetupEmbedMsg from './general-logistics-setup-embed-msg';
  import MsgDialog from '../../../public-component/msg-dialog';
  import LoadingDialog from '../../../public-component/loading-dialog';

  export default {
    name: 'general-logistics-setup',
    components: {GeneralLogisticsSetupEmbedMsg, MsgDialog, LoadingDialog},
    data() {
      return {
        list: [], // 列表信息
        checkAll: false, // 全选
        checkboxModel: [], // checkbox框值
        channelList: [], // 渠道下拉
        // selectChannel: '', // 渠道选择
        selectChannel: [], // 渠道选择  2022.07.18 改传多选项
        codeClassificationList: [], // 查询分类下拉
        // selectClassificationType: '', // 选择的分类
        selectClassificationType: [], // 选择的分类  2022.07.18 改传多选项
        provincesList: [], // 省份下拉
        selectProvince: null, // 选择的省份
        courierCompanyList: [], // 快递公司下拉
        // selectCourierCompany: '', // 选择的快递公司
        selectCourierCompany: [], // 选择的快递公司  2022.07.18 改传多选项
        storeList: [], // 店铺下拉
        // selectStore: '', // 店铺选择
        selectStore: [], // 店铺选择  2022.07.18 改传多选项
        selectSymbolType: 0, // 选择的符号
        symbolType: [
          {id: 0, text: '符号'},
          {id: 1, text: '='},
          {id: 2, text: '>'},
          {id: 3, text: '>='},
          {id: 4, text: '<'},
          {id: 5, text: '<='}
        ], // 符号类型下拉列表
        minNum: null, // 最小数值
        maxNum: null, // 最大数值
        isLoading: false, // 是否显示加载框
        isShow: false, // 提示框显示
        dialogTitle: null, // 弹出框头部名
        dialogShowType: null, // 弹出框类型
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '', // 信息框内容
        currentPage: 1, // 当前页数
        pageSize: 10, // 当前显示几条数据
        total: 0 // 总条数
      }
    },
    methods: {
      // tabs切换
      tabsChange(value) {
        this.$emit('tabschange', {type: value});
      },

      query() {
        this.currentPage = 1;
        this.getStoreroomProvinceLogisticPageData();
      },

      // 获取店铺下拉框信息
      getAllPXShopList() {
        this.$axios.get(this.Global.getAllPXShopList).then((res) => {
          if (!res.data.errorMsg) {
            if (res.data.resData.length) {
              this.storeList = res.data.resData;
              // this.selectStore = res.data.resData[0].id;
              // this.storeList.splice(this.storeList.findIndex(item => item.id === 0), 1);
            } else {
              this.storeList = res.data.resData;
              // this.selectStore = '';
              this.selectStore = [];
            }
            // this.storeList.splice(0, 0, {id: '', text: '所有店铺'});
          } else {
            this.storeList = [];
            // this.selectStore = res.data.errorMsg;
            this.selectStore = [];
          }
        });
      },

      // 获取渠道下拉框信息
      getAllStoreroomsList() {
        this.$axios.get(this.Global.getAllStoreroomsList).then((res) => {
          if (!res.data.errorMsg) {
            this.channelList = res.data.resData;
            // this.channelList.splice(0, 0, {id: '', text: '所有渠道'});
            // this.selectChannel = '';
            this.selectChannel = [];
          } else {
            this.channelList = [];
            // this.selectChannel = res.data.errorMsg;
            this.selectChannel = [];
          }
        });
      },

      // 加载分类下拉数据
      getAllClassList() {
        this.$axios.get(this.Global.getAllClassList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.codeClassificationList = res.data.resData;
            // this.codeClassificationList.splice(0, 0, {id: '', text: '所有分类'});
            // this.selectClassificationType = '';
            this.selectClassificationType = [];
          } else {
            this.codeClassificationList = [];
            // this.selectClassificationType = res.data.errorMsg;
            this.selectClassificationType = [];
          }
        });
      },

      // 获取省份下拉框
      getAllProvinceList() {
        this.$axios.get(this.Global.getAllProvinceList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.provincesList = res.data.resData;
            this.provincesList.splice(0, 0, {id: null, text: '省份'});
            this.selectProvince = null;
          } else {
            this.provincesList = [];
            this.selectProvince = res.data.errorMsg;
          }
        });
      },

      // 获取快递公司下拉框
      getAllLogisticList() {
        this.$axios.get(this.Global.getAllLogisticList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.courierCompanyList = res.data.resData;
            // this.courierCompanyList.splice(0, 0, {id: '', text: '所有快递'});
            // this.selectCourierCompany = '';
            this.selectCourierCompany = [];
          } else {
            this.courierCompanyList = [];
            // this.selectCourierCompany = res.data.errorMsg;
            this.selectCourierCompany = [];
          }
        });
      },

      // 数值判断
      judgeNum(num, type) {
        if (typeof num === 'string') {
          if (type === 'min') {
            this.minNum = null;
          } else {
            this.maxNum = null;
          }
        } else if (num === 0) {
          if (type === 'min') {
            this.minNum = 0;
          } else {
            this.maxNum = 0;
          }
        } else if (this.minNum > this.maxNum) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '最小值不能大于最大值';
        }
      },

      // 加载渠道配省份物流分页数据
      getStoreroomProvinceLogisticPageData() {
        if (this.minNum > this.maxNum) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '最小值不能大于最大值';
          return;
        }
        this.isLoading = true;
        const params = {
          storeroomId: this.selectChannel,
            shopId: this.selectStore,
          logisticId: this.selectCourierCompany,
          provinceId: this.selectProvince,
          classId: this.selectClassificationType,
          minPrice: this.minNum,
          maxPrice: this.maxNum,
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.$axios.post(this.Global.getStoreroomProvinceLogisticPageData, params).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            self.isLoading = false;
            clearTimeout(timer);
            if (!res.data.errorMsg.length) {
              self.checkAll = false;
              self.checkboxModel = [];
              self.list = res.data.resData.DataList;
              self.total = res.data.resData.TotalCounts;
              for (let i = 0; i < self.list.length; i++) {
                self.checkboxModel.push(false);
              }
            } else {
              self.isMsg = true;
              self.isSuc = false;
              self.txtMsg = res.data.errorMsg;
            }
          }, 500);
        });
      },

      // 操作按钮
      ctrlBtn(type, msg) {
        this.dialogShowType = type;
        let arr = [];
        switch (type) {
          case 'add':
            this.isShow = true;
            this.dialogMsg = msg;
            this.dialogTitle = '添加';
            break;
          case 'del':
            this.isShow = true;
            arr.push(msg.Id);
            this.dialogMsg = arr;
            this.dialogTitle = '提示';
            break;
          case 'batchDel':
            for (let i in this.checkboxModel) {
              if (this.checkboxModel[i]) {
                arr.push(this.list[i].Id);
              }
            }
            if (!arr.length) {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = '请选择要批量删除的数据';
              return;
            }
            this.isShow = true;
            this.dialogMsg = arr;
            this.dialogTitle = '提示';
            break;
        }
      },

      // 单选/全选
      checkOneOrAll() {
        for (let i = 0; i < this.checkboxModel.length; i++) {
          this.checkboxModel[i] = !this.checkAll;
        }
      },

      // 分页——当前页面显示条数改变
      handleSizeChange(val) {
        this.pageSize = val;
        if (val < this.checkboxModel.length) {
          this.checkboxModel = this.checkboxModel.splice(0, val);
        }
        this.getStoreroomProvinceLogisticPageData();
      },

      // 分页——当前页改变
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getStoreroomProvinceLogisticPageData();
        this.checkboxModel = [];
        for (let i in this.list) {
          console.log(i);
          this.checkboxModel.push(false);
        }
      },

      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        this.isShow = e.isShow;
        if (e.handleType) {
          if (this.dialogShowType === 'del' || this.dialogShowType === 'batchDel') {
            this.currentPage = 1;
          }
          this.getStoreroomProvinceLogisticPageData();
          this.checkboxModel = [];
          for (let i in this.list) {
            this.checkboxModel.push(false);
          }
          // this.isMsg = true;
          // this.isSuc = true;
          // this.txtMsg = '操作成功';
        }
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      }
    },
    created() {
      this.getStoreroomProvinceLogisticPageData();
      this.getAllStoreroomsList();
      this.getAllClassList();
      this.getAllProvinceList();
      this.getAllLogisticList();
      this.getAllPXShopList();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../assets/css/home-view";

  .goods_logistics_setup_top {
    /*height: 52px;*/

    & > div {
      display: inline-block;
      margin: 10px 5px;
      float: left;

      &:last-child {
        display: block;
        width: 100%;
        margin: 0 0 10px;

        button {
          float: right;
        }
      }
    }
  }

  .goods_logistics_setup_content {
    padding: 0 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/goods-management/default-delivery-logistics/general-logistics-setup.vue